export default function isSymbol(val) {
  return typeof val === 'symbol';
};